import {FixedFilters} from "../Project/Plugins/FixedFilters";

;(function ($) {

    function renderVariants(elem) {
        var uri = $(elem).data('variants');
        var tmplStringRenderTarget = $('#ajax-article-variants-render-target--tpl').html();
        var tmplStringFilters = $('#ajax-article-variants-filter--tpl').html();
        var tmplStringList = $('#ajax-article-variants-list--tpl').html();
        var tmplStringFilterChoices = $('#ajax-article-variants-filter-choices-tpl').html();
        var tmplStringSortingChoices = $('#ajax-article-variants-sorting-choice-tpl').html();
        var tmplRenderTarget = _.template(tmplStringRenderTarget);
        var tmplFilterChoices = _.template(tmplStringFilterChoices || '');
        var tmplSortingChoices = _.template(tmplStringSortingChoices || '');
        var tmplFilters = _.template(tmplStringFilters);
        var tmplList = _.template(tmplStringList);
        var renderTarget = $('.article-variants-render-target', $(elem).data('target') ? $($(elem).data('target')) : elem);

        if (renderTarget.length) {
            renderTarget = renderTarget.get(0)
        } else {
            $(elem).append(tmplRenderTarget({}));
            renderTarget = $('.article-variants-render-target', elem).get(0);
        }

        var d = {
            articles: [],
            filters: []
        };

        function doSort(idx) {
            var sortFields = getSortFields();
            d.articles = _.orderBy(
                d.articles,
                _.get(sortFields, 'sorts[' + idx + '].field', 'product'),
                _.get(sortFields, 'sorts[' + idx + '].direction', 'asc')
            );
            update();
        }

        function getSortFields() {
            var sortFields = {
                sorts: [
                    {
                        label: 'Artikelnummer',
                        field: 'product',
                        direction: 'asc'
                    },
                    {
                        label: 'Top-Produkte',
                        field: 'top',
                        direction: 'desc'
                    },
                    {
                        label: 'Beschreibung',
                        field: 'product',
                        direction: 'asc'
                    }
                ]
            }

            var filters = Array.isArray(d.filters) ? d.filters : _.values(d.filters);

            filters.forEach(function (filter) {
                sortFields.sorts.push({
                    label: filter.title,
                    field: (function (key) {
                        return function (article) {
                            var attrs = _.get(article, 'attributes', []);
                            var att = _.find((Array.isArray(attrs) ? attrs : _.values(attrs)), function (attr) {
                                return attr.title === key;
                            });
                            return _.get(att, 'value');
                        }
                    })(filter.title),
                    direction: 'asc'
                })
            });

            return sortFields;
        }

        // filter articles
        function runFilters(data, filterKeyValues) {
            return _.filter(_.get(data, 'articles', []), function (article) {
                return Object.keys(filterKeyValues).reduce(function (prev, key) {
                    var attrs = _.get(article, 'attributes', []);
                    var aValue = _.get(
                        _.find((Array.isArray(attrs) ? attrs : _.values(attrs)), function (attr) {
                            return attr.title === key;
                        }),
                        'value'
                    );
                    return prev && (filterKeyValues[key].indexOf(aValue) > -1 || filterKeyValues[key].length === 0)
                }, true);
            });
        }

        function disableFilterOptions(articles) {
            var appliedFilters = getAppliedFilters(renderTarget);
            $(renderTarget).find('select.selectpicker').each(function (idx, select) {
                // disable options that cause empty results
                $('option', select).each(function (idx, option) {
                    var optionEnabled = true;
                    $(option).removeClass('will-not-shrink-result will-shrink-result will-add-result');

                    if (!$(option).is(':selected')) {
                        var appliedFiltersCopy = _.cloneDeep(appliedFilters);

                        appliedFiltersCopy[select.name] = [].concat(appliedFiltersCopy[select.name], [option.value]);
                        var eventualResult = runFilters(d, appliedFiltersCopy);
                        if (eventualResult.length === 0) {
                            optionEnabled = false;
                        } else if (eventualResult.length === articles.length) {
                            $(option).addClass('will-not-shrink-result');
                        } else if (eventualResult.length < articles.length) {
                            $(option).addClass('will-shrink-result');
                        } else if (eventualResult.length > articles.length) {
                            $(option).addClass('will-add-result');
                        }
                    }
                    $(option).attr('disabled', optionEnabled ? null : 'disabled');
                });

                $(select).selectpicker('render');

                // mark options that will not reduce results
                $('option', select).each(function (idx, option) {
                    var li = $('li[data-original-index=' + idx + ']', select.parentNode);
                    li.addClass($(option).attr('class'));
                });
            });
        }

        function updateFilterChoices(appliedFilters) {
            var target = $('.filter-choices', renderTarget);
            target.empty().append(tmplFilterChoices({appliedFilters: appliedFilters}));

            $('.remove-all-filters', target).click(function () {
                $(renderTarget).find('select.selectpicker').each(function (idx, select) {
                    $(select).selectpicker('deselectAll');
                });

                update(renderTarget);
            });

            $('.filter-value-remove', target).click(function (e) {
                const filterName = $(e.currentTarget).data('filter');
                const optionValue = $(e.currentTarget).data('value');

                /** @type {HTMLSelectElement} */
                const select = renderTarget.querySelector('select[name="' + filterName + '"]');

                Array.from(select.selectedOptions).forEach((option) => {
                    if (option.value === optionValue) {
                        option.selected = false;
                    }
                });

                $(select).selectpicker('val', $(select).val());

                update(renderTarget);
            });
        }

        function getAppliedFilters() {
            var appliedFilters = {};
            $(renderTarget).find('select.selectpicker').each(function (idx, select) {
                var v = [];
                $('option:selected', select).each(function (idx, elem) {
                    v.push($(elem).val());
                });
                appliedFilters[select.name] = v;
            });
            return appliedFilters;
        }

        function update() {
            var appliedFilters = getAppliedFilters(renderTarget);
            var filteredArticles = runFilters(d, appliedFilters);

            $('.article-list-filtered', renderTarget).replaceWith(tmplList({articles: filteredArticles}));

            disableFilterOptions(filteredArticles, renderTarget);
            updateFilterChoices(appliedFilters, renderTarget);

            initExternal();
        }

        function initExternal() {
            $(renderTarget).find('*[data-annotations]').annotations();
            $(renderTarget).find('.price-async').prices();
            $(renderTarget).find('.shopping-button-async').shoppingButton();
            $(renderTarget).find('*[data-fetch-article-buy]').articleBuy();

            window.initAvailabilityPopovers();
        }

        /**
         * Add apply button to multiple selects
         */
        function addApplyButtonToSelect () {
            $(renderTarget).find('select.selectpicker').on('loaded.bs.select', function () {
                if ($(this).attr('multiple') == 'multiple') {
                    var dropdownMenu = $(this).parent().find('div.dropdown-menu');
                    dropdownMenu.append('<div class="apply-button"><button class="btn btn-primary">' + globalTranslations.searchFilterApplyButton + '</button></div>');
                }
            });
        }

        /**
         * Initialize the apply buttons
         */
        function initializeApplyButton () {
            $(renderTarget).on('click touchend', '.apply-button .btn', function() {
                update(renderTarget);
            });
        }

        if (uri && tmplStringList && tmplStringFilters) {

            $.getJSON(uri, function (data) {
                d = data;

                $(renderTarget).empty();

                var filters = Array.isArray(d.filters) ? d.filters : _.values(d.filters);
                if (filters.length > 0) {
                    $(renderTarget).append(tmplFilters(data));
                    FixedFilters.createInstances($(renderTarget).find('.product-filters'), true);
                }

                $(renderTarget).append(tmplSortingChoices(getSortFields()));
                $(renderTarget).append(tmplList(data));

                $(renderTarget).on('change', '.overlay-sort-dropdown', function () {
                    doSort(this.value)
                });

                initExternal();
                $(renderTarget).find('select.selectpicker').selectpicker({
                    style: ''
                });

                addApplyButtonToSelect();
                initializeApplyButton();
            });
        }
    }

    $.fn.ajaxVariants = function () {
        $(this).each(function (i, n) {
            renderVariants(n);
        });

        return this;
    }
})(jQuery);
